import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './bootstrap.component.html',
  styleUrls: ['./bootstrap.component.css']
})
export class BootstrapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
